import {
  Flex,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  HStack,
  Box,
} from '@chakra-ui/react';

import DateField from 'components/fields/DateField';
import SectionCard from '../../components/SectionCard';
import { useAnswerCodes } from '../../hooks';
import { CUSTOMER_TYPES, type PropertyPolicyBasicInfoProps } from './types';

const PropertyPolicyBasicInfo = ({
  effectiveDate,
  customerType,
  onFieldChange,
  isUpdating,
}: PropertyPolicyBasicInfoProps) => {
  const { isEffectiveDateValid } = useAnswerCodes();
  const isEffectiveDateInvalid = !isEffectiveDateValid;

  return (
    <SectionCard mb={4}>
      <Flex
        direction={{ base: 'column', lg: 'row' }}
        gap={{ base: 6, lg: 12 }}
        align={{ base: 'stretch', lg: 'flex-start' }}
      >
        <Flex gap={6} align="end" wrap="wrap" flex="1">
          <Box minW="160px">
            <DateField
              label="Effective Date"
              date={
                effectiveDate ? new Date(effectiveDate + 'T00:00:00') : null
              }
              required
              isInvalid={isEffectiveDateInvalid}
              isDisabled={isUpdating}
              onChange={(date: Date | null) => {
                if (date) {
                  const year = date.getFullYear();
                  const month = String(date.getMonth() + 1).padStart(2, '0');
                  const day = String(date.getDate()).padStart(2, '0');
                  onFieldChange('effective_date', `${year}-${month}-${day}`);
                } else {
                  onFieldChange('effective_date', '');
                }
              }}
            />
          </Box>
        </Flex>

        <FormControl maxW={{ base: '100%', lg: '250px' }}>
          <FormLabel fontSize="sm" fontWeight="600">
            Customer Type
          </FormLabel>
          <RadioGroup
            value={customerType || 'individual'}
            onChange={(v) => onFieldChange('customer_type', v)}
            isDisabled={isUpdating}
          >
            <HStack spacing={4}>
              {CUSTOMER_TYPES.map((type) => (
                <Radio key={type.value} value={type.value} colorScheme="blue">
                  {type.label}
                </Radio>
              ))}
            </HStack>
          </RadioGroup>
        </FormControl>
      </Flex>
    </SectionCard>
  );
};

export default PropertyPolicyBasicInfo;
